import { render, staticRenderFns } from "./test-list.vue?vue&type=template&id=d3bc8f2c"
import script from "./test-list.vue?vue&type=script&lang=js"
export * from "./test-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports